module.exports = __webpack_public_path__ + "static/media/Logo.21b9f975.png";